import { useLazyContext } from "@redotech/react-util/context";
import { ConversationTagInput } from "@redotech/redo-merchant-support-app/conversation-tags/conversation-tag-input";
import { ConversationTagsContext } from "@redotech/redo-merchant-support-app/services/conversation-tags-service";
import type { HasTagCondition as HasTagConditionType } from "@redotech/redo-model/advanced-flow/rules/schemas";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useMemo } from "react";

export const HasTagCondition = memo(function HasTagCondition({
  condition,
  onChange,
  editableFields,
}: {
  condition: HasTagConditionType;
  onChange: (updated: HasTagConditionType) => void;
  editableFields?: ReadonlySet<string>;
}) {
  const [conversationTags] = useLazyContext(ConversationTagsContext);
  const tagsEditable =
    editableFields === undefined || editableFields.has("tags");

  const tagNames = useMemo(
    () => new Set(condition.tags ?? []),
    [condition.tags],
  );

  const tags = useMemo(
    () => conversationTags.value?.filter((tag) => tagNames.has(tag.name)) ?? [],
    [conversationTags.value, tagNames],
  );

  return (
    <Flex dir="column" gap="sm" w="full">
      {/* ConversationTagInput has no native `disabled` prop; the wrapper locks
          pointer interactions just for this input. */}
      <Flex
        style={
          tagsEditable ? undefined : { pointerEvents: "none", opacity: 0.6 }
        }
      >
        <ConversationTagInput
          currentTags={tags}
          setCurrentTags={(updated) => {
            if (!tagsEditable) return;
            onChange({ ...condition, tags: updated.map((tag) => tag.name) });
          }}
          showAddButtonToEnterInput
        />
      </Flex>
    </Flex>
  );
});
